<!-- Universal Popup Window -->

<template>
	<div class="pop-main-shadow" ref="popupContainer" > <!-- @click="goClose"> -->
		<div class="frame" @click.stop>
			<div class="header">
				<div class="title  wi8_font" v-html="title">
				</div>
				<div class="close_box" @click="goClose">
					<UniIcon 
						ico="cancel"
						fit="1"
						pad="12"
						color="#C30"
					/>
				</div>
			</div>

			<div class="spacer">
			</div>

			<div class="content" v-if="validComponent">
				<component :is="popData.compName" :compData="popData.compData"></component>
			</div>

			<div class="oops wi8_font" v-else>
				<UniIcon ico="notice" color="#C30" w="26" h="26" pad="0" />
				{{ popData.compName }} is not a valid component.
			</div>

		</div>
	</div>
</template>

<script>
import { m } from "@/utils/utils";
import Vue from "vue";
import { eventBus } from '@/main';
import * as Utils from '@/utils/utils';
export default {
	props: {
		popData: { type: Object, default: function () {return {}} },
	},
	data() {
		return {
			title: "",
			validComponent: false,
		}
	},
	methods: {
		goClose() {
			m("win " + this.popData.popIdx + " go close");	
			eventBus.$emit("popoff");
		},
		handleCloseIdx(idx) {
			m("win " + this.popData.popIdx + " handle close " + idx);
			if (idx == this.popData.popIdx) {
				m("win " + this.popData.popIdx + " closing");
				this.goClose();
			}
		},
	},
	created() {
		this.title = Utils.break2Br(this.popData.popTitle);
		this.validComponent = (this.popData.compName in Vue.options.components);
		this.popData.compData = {...this.popData.compData, modal:true}; // Inject modal flag into component data
		eventBus.$on('popcloseidx', this.handleCloseIdx);
	},
	beforeDestroy() {
		eventBus.$off('popcloseidx', this.handleCloseIdx);
	},
	mounted() {
		const obj = this.$refs['popupContainer'];
		// this.$nextTick( function() {
		// 	obj.className += " fadein";
		// })
		setTimeout(() => {
			obj.className += " fadein";
		}, 10);
	},
}
</script>

<style scoped>
.pop-main-shadow {
	width: 100%;
	height: 100%;
	overflow: hidden;
	/* background-color: #999; */
	/* opacity: 0.5; */
	background:rgba(100, 100, 100, .5);
	padding: 20px;
	border-radius: 8px;
	border: solid 0px #F60;

	opacity: 0;
	transition: all .2s ease;
}

.fadein {
	opacity: 1;
}

.frame {
	width: 100%;
	height: 100%;
	overflow: hidden;
	/* background:rgba(255, 255, 255,1); */
	opacity: 1;
	background-color: #F9F6F3;
	padding: 0px;
	border-radius: 8px;
	border: solid 0px #CCC;
	border-top: solid 2px #FFF;
	border-left: solid 2px #FFF;
	border-right: solid 2px #666;
	border-bottom: solid 2px #666;
}

.header {
	height: 65px;
	border: solid 0px #963;
}

.title {
	float:left;
	height: 60px;
	width: calc(100% - 55px);
	overflow: hidden;
	font-size: 15px; 
	line-height: 20px;
	/* text-align: center; */
	padding: 10px 0px 0px 10px;
	border: solid 0px #999;
}

.close_box {
	float:right;
	width: 48px;
	height: 48px;
	overflow: hidden;
	cursor: pointer;
	border: solid 0px #C30;
}

.spacer {
	clear: both;
	width: 10px;
	height: 5px;
	border: solid 0px #000;
}

.content {
	width: 100%;
	height: calc(100% - 70px);
	overflow: hidden;
	padding: 0;
	border: solid 0px #090;
}


.oops {
	color: #C30;
	padding: 20px;
	border: solid 0px #C30;
}

</style>
